import _ from "lodash";
import React, { Component } from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { getDonorsFromFolder } from "../../../utils/donorHelpers";
import { bestFit } from "../../../utils/screenUtils";
import { dp, dpath, parseTextStyling } from "../../../utils/shared";
import BRSpan from "../../General/BRSpan";
import BGWrapper from "./BGWrapper";

const DEFAULT_CYCLE = 10;
class NewarkDonorList2 extends Component {
  constructor(props) {
    super(props);

    const dims = bestFit(1920, 1080, props.width || 1920, props.height || 1080);

    this.state = {
      listData: {
        donors: [],
        title: "",
        category: "",
        description: "",
        cycleIndex: 0
      },
      slide: "",
      background: "",
      timestamp: null,
      finishedPreRender: false,
      fadeIn: true,
      width: dims.width,
      height: dims.height,
      showDonors: false,
      showSlides: false
    };

    this._background = null;
    this._interstitialTimeoutHandler = null;
    this._donorCounter = 0;
    this._manualSlidesIndex = 0;
    this._manualSlidesInnerIndex = 0;
    this._donorCycleTimeout = null;
    this.donorList = null;
    this._donorRefs = [];
    this._underlineRef = null;
    this._donorContainerRef = null;
    this._donorContainer = {
      height: 0,
      width: 0
    };
    this._donorIndex = 0;
    this._categoryIndex = 0;
    this._lastPageCount = 0;
    // this._cycle_time = 5000;

    this._layout = {
      margin_left: 0.05,
      margin_bottom: 0.1,
      title_offset: 0.025,
      description_offset: 0.1,
      names_offset: 0.125
    };
  }

  componentWillMount() {
    let donors = getDonorsFromFolder(
      this.props.donors,
      this.props.content.folder_modules,
      this.props.module.id
    );
    donors = _.orderBy(donors, [d => d.sorting_name.toLowerCase()], ["asc"]);
    this._donorList = { ...this.props.module, donors };
  }

  componentDidMount() {
    const columns = _.get(
      this._donorList,
      "contents.custom_fields.columns.val",
      _.get(this._donorList, "contents.custom_fields.columns.default", 2)
    );
    const marginLeft = _.get(
      this._donorList,
      "contents.custom_fields.margin_left.val",
      _.get(this._donorList, "contents.custom_fields.margin_left.default", 0)
    );
    const donorMarginLeft = _.get(
      this._donorList,
      "contents.custom_fields.donor_margin_left.val",
      _.get(
        this._donorList,
        "contents.custom_fields.donor_margin_left.default",
        0
      )
    );
    const topOffset = _.get(
      this._donorList,
      "contents.custom_fields.top_offset.val",
      _.get(this._donorList, "contents.custom_fields.top_offset.default", 0)
    );
    const titleOffset = _.get(
      this._donorList,
      "contents.custom_fields.title_offset.val",
      _.get(this._donorList, "contents.custom_fields.title_offset.default", 2.5)
    );
    const descriptionOffset = _.get(
      this._donorList,
      "contents.custom_fields.description_offset.val",
      _.get(
        this._donorList,
        "contents.custom_fields.description_offset.default",
        0
      )
    );
    const containerWidth = _.get(
      this._donorList,
      "contents.custom_fields.donor_container_width.val",
      _.get(
        this._donorList,
        "contents.custom_fields.donor_container_width.default",
        80
      )
    );
    const containerHeight = _.get(
      this._donorList,
      "contents.custom_fields.donor_container_height.val",
      _.get(
        this._donorList,
        "contents.custom_fields.donor_container_height.default",
        65
      )
    );

    const slides = _.get(this._donorList, "contents.arrays_values.slides", []);
    const slideshowModuleId = _.get(
      this._donorList,
      "contents.custom_fields.slideshow.val.value",
      null
    );
    if (slideshowModuleId) {
      const slideshowModule = this.props.content.dm_active.find(
        dm => dm.id === slideshowModuleId
      );
      if (slideshowModule) {
        this._slideshowModule = slideshowModule;
        const manualSlides = slides.map(s => {
          return {
            page: Number(s.page.val),
            start: Number(s.start_slide.val),
            end: Number(s.end_slide.val)
          };
        });
        this._manualSlides = manualSlides;
      }
    }

    this._layout.columns = columns / 100;
    this._layout.margin_left = marginLeft / 100;
    this._layout.donor_margin_left = donorMarginLeft / 100;
    this._layout.names_offset = topOffset / 100;
    this._layout.title_offset = titleOffset / 100;
    this._layout.description_offset = descriptionOffset / 100;
    this._layout.container_width = containerWidth / 100;
    this._layout.container_height = containerHeight / 100;

    try {
      document.addEventListener("keydown", this.handleKeyDown);
      setTimeout(() => {
        this.handlePreRender();
        this.setDonorListStateData();
        this.cycleNameSet();
      }, 500);
    } catch (e) {
      console.log(e);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.width !== this.props.width ||
      prevProps.height !== this.props.height
    ) {
      const dims = bestFit(1920, 1080, this.props.width, this.props.height);
      this.setState({
        width: dims.width,
        height: dims.height
      });
    }
  }

  componentWillUnmount() {
    clearTimeout(this._donorCycleTimeout);
  }

  getBackground = (i = 0) => {
    const { module } = this.props;
    let imgObj = _.get(module, `contents.images[${i}]`, null);
    if (imgObj) {
      return dp({ mode: this.props.screen.mode }, imgObj, null);
    }
    return null;
  };

  setDonorListStateData = () => {
    const title = _.get(
      this._donorList,
      "contents.custom_fields.main_header.val",
      ""
    );
    const category = _.get(this._donorList, "description", "");
    const description = _.get(
      this._donorList,
      "contents.custom_fields.description.val",
      ""
    );

    this.setState({
      listData: {
        title,
        category,
        description
      }
    });
  };

  handlePreRender = () => {
    if (this._donorRefs.length > 0 && this.state.finishedPreRender === false) {
      let counter = -1;
      this._donorList.donors.forEach(donor => {
        counter++;
        donor.height = this._donorRefs[counter].offsetHeight;
        donor.width = this._donorRefs[counter].offsetWidth;
      });

      this._donorContainer = {
        width: this._donorContainerRef.offsetWidth,
        height: this._donorContainerRef.offsetHeight
      };
      this.setState({
        finishedPreRender: true
      });
    }
  };

  handleKeyDown = event => {
    switch (event.key) {
      case "c":
        this.cycleDonorIndex();
        break;
      default:
        break;
    }
  };

  getCategoryStyle = (style = {}) => {
    style.fontSize = this.state.height * 0.026;
    style.fontStyle = "Normal";
    style.fontFamily = "Lato";
    style.fontWeight = "100";
    style.paddingBottom = this.state.height * 0.008;
    style.lineHeight = 2.75;
    style.textAlign = "left";
    style.fontColor = "#000000";

    return style;
  };

  preRenderDonors = () => {
    let flatDonors = [];
    const columns = _.get(
      this._donorList,
      "contents.custom_fields.columns.val",
      _.get(this._donorList, "contents.custom_fields.columns.default", 3)
    );
    let columnWidth = (this.state.width * 0.8) / columns;
    const styleObj = _.get(
      this._donorList,
      "contents.custom_fields.donor_name_style",
      null
    );
    const style = parseTextStyling(styleObj);
    // style.lineHeight = "4vh";
    this._donorList.donors.forEach(donor => {
      donor.style = style;
      donor.style.width = columnWidth * 0.9;
      flatDonors.push(donor);
    });

    return flatDonors.map((donor, i) => {
      return (
        <div
          key={i}
          ref={el => (this._donorRefs[i] = el)}
          style={{ ...donor.style, opacity: 0 }}
        >
          <BRSpan str={donor.name} />
        </div>
      );
    });
  };

  cycleNameSet = cycleTimeOverride => {
    const interstitial = _.get(
      this._donorList,
      "contents.custom_fields.interstitial.val",
      _.get(
        this._donorList,
        "contents.custom_fields.interstitial.default",
        false
      )
    );
    let cycleTime = _.get(
      this.props.module,
      "contents.custom_fields.cycle_time.val",
      DEFAULT_CYCLE
    );

    if (cycleTimeOverride) {
      cycleTime = cycleTimeOverride;
    }

    clearTimeout(this._donorCycleTimeout);

    if (interstitial && this._manualSlides && this._manualSlides.length) {
      this.handleInterstitial();
    } else {
      this._background = this.getBackground();
      this.setState({ showDonors: true });
      this._donorCycleTimeout = setTimeout(() => {
        const endOfLoop = this.cycleDonorIndex();
        if (!endOfLoop) {
          this._background = this.getBackground();
          this.setState({ showDonors: true, showSlides: false });
          this.cycleNameSet();
        } else {
          if (this.props.cycle && !this.props.useOnlyInnerCycle) {
            this.props.cycle();
          } else {
            this._donorIndex = 0;
            this.cycleNameSet();
          }
        }
      }, cycleTime * 1000);
    }
  };

  cycleDonorIndex = () => {
    if (
      this._donorIndex + this._lastPageCount >=
      this._donorList.donors.length
    ) {
      return true;
    } else {
      this._donorIndex += this._lastPageCount;
      return false;
    }
  };

  handleInterstitial = () => {
    let slideTimeout = DEFAULT_CYCLE;
    const currentSlide = this._manualSlides.find(
      s => s.page === this._manualSlidesIndex
    );
    const totalSteps =
      _.get(currentSlide, "page", 0) +
      _.get(currentSlide, "end", 0) -
      _.get(currentSlide, "start", 0) +
      1;
    const stepsLeft = totalSteps - this._manualSlidesInnerIndex;

    if (currentSlide && stepsLeft > 0) {
      const slidePath = dpath(
        this.props.screen.mode,
        this._slideshowModule.contents.images[this._manualSlidesInnerIndex]
          .path,
        this._slideshowModule.contents.images[this._manualSlidesInnerIndex]
          .file_name,
        this.props.screen.webkey
      );

      slideTimeout = DEFAULT_CYCLE;
      const hasCycleOverride = _.has(
        this._slideshowModule,
        `contents.cycle_overrides[${this._manualSlidesInnerIndex}]`
      );
      if (hasCycleOverride) {
        slideTimeout = this._slideshowModule.contents.cycle_overrides[
          this._manualSlidesInnerIndex
        ];
      }

      this._manualSlidesInnerIndex++;
      this._donorCounter++;
      this._background = slidePath;
      this.setState({
        showSlides: true,
        showDonors: false
      });
      clearTimeout(this._interstitialTimeoutHandler);
      this._interstitialTimeoutHandler = setTimeout(() => {
        this.handleInterstitial();
      }, slideTimeout * 1000);
    } else {
      this._manualSlidesIndex++;
      const cycleTime = _.get(
        this.props.module,
        "contents.custom_fields.cycle_time.val",
        DEFAULT_CYCLE
      );
      this._background = this.getBackground();
      this._donorCounter++;
      this.setState({
        showDonors: true,
        showSlides: false
      });
      clearTimeout(this._interstitialTimeoutHandler);
      this._interstitialTimeoutHandler = setTimeout(() => {
        const endOfLoop = this.cycleDonorIndex();
        if (endOfLoop) {
          if (this.props.cycle) {
            this.props.cycle();
          } else {
            this._donorIndex = 0;
            this.handleInterstitial();
          }
        } else {
          this.handleInterstitial();
        }
      }, cycleTime * 1000);
    }
  };

  renderNames = () => {
    const donorCategory = this._donorList;
    const columns = _.get(
      donorCategory,
      "contents.custom_fields.columns.val",
      _.get(donorCategory, "contents.custom_fields.columns.default", 3)
    );
    let currentHeight = 0;
    let currentColumn = 1;
    let drawDonors = [];
    let columnWidth = this._donorContainer.width / columns;
    this._lastPageCount = 0;

    for (var a = this._donorIndex; a < this._donorList.donors.length; a++) {
      let donor = this._donorList.donors[a];
      //fits in column
      if (
        currentHeight + donor.height >
        this._donorContainer.height -
          this._layout.margin_bottom * this.state.height
      ) {
        if (currentColumn < columns) {
          //reset for new column
          currentHeight = 0;
          currentColumn++;
        } else {
          break;
        }
      }

      donor.top = currentHeight;
      donor.column = currentColumn;
      const verticalOffset = _.get(
        this.props.module,
        "contents.custom_fields.donor_vertical_offset.val",
        _.get(
          this.props.module,
          "contents.custom_fields.donor_vertical_offset.default",
          5
        )
      );
      currentHeight +=
        donor.height + (this.props.height * Number(verticalOffset)) / 100;
      drawDonors.push(donor);
      this._lastPageCount++;
    }

    const styleObj = _.get(
      this._donorList,
      "contents.custom_fields.donor_name_style",
      null
    );
    const style = parseTextStyling(styleObj);
    // style.lineHeight = "4vh";

    return drawDonors.map((item, i) => {
      const left =
        (item.column - 1) * columnWidth * (1 + this._layout.donor_margin_left);
      return (
        <div
          key={i}
          style={{
            ...style,
            position: "absolute",
            overflow: "hidden",
            top: item.top,
            left,
            opacity: 1,
            width: columnWidth * 0.9
          }}
        >
          <div className="empty-br">
            <BRSpan className="empty-br" str={item.name} />
          </div>
        </div>
      );
    });
  };

  render() {
    if (
      !this._donorList ||
      !this._donorList.donors ||
      !this._donorList.donors.length
    ) {
      return null;
    }
    const margin_left = this.state.width * this._layout.margin_left;
    const title_offset = this.state.height * this._layout.title_offset;
    const description_offset =
      this.state.height * this._layout.description_offset;
    const names_offset = this.state.height * this._layout.names_offset;

    const titleStyleObj = _.get(
      this._donorList,
      "contents.custom_fields.parent_category_name",
      null
    );
    const titleStyle = parseTextStyling(titleStyleObj);
    const subheaderStyleObj = _.get(
      this._donorList,
      "contents.custom_fields.subcategory_name",
      null
    );
    const subheaderStyle = parseTextStyling(subheaderStyleObj);
    // const deceased = _.get(this._donorList, 'contents.custom_fields.deceased.val', false);
    // const underline = _.get(this._donorList, 'contents.custom_fields.horizontal_line.val', _.get(this._donorList, 'contents.custom_fields.horizontal_line.default', false));
    const containerWidth =
      (this.state.width *
        Number(
          _.get(
            this._donorList,
            "contents.custom_fields.donor_container_width.val",
            _.get(
              this._donorList,
              "contents.custom_fields.donor_container_width.default",
              80
            )
          )
        )) /
      100;
    const containerHeight =
      (this.state.height *
        Number(
          _.get(
            this._donorList,
            "contents.custom_fields.donor_container_height.val",
            _.get(
              this._donorList,
              "contents.custom_fields.donor_container_height.default",
              65
            )
          )
        )) /
      100;

    return (
      <div>
        <CSSTransitionGroup
          component="div"
          transitionName="slowfade"
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}
        >
          <div key={this._donorCounter}>
            <BGWrapper
              width={this.state.width}
              height={this.state.height}
              background={this._background}
            />
          </div>
        </CSSTransitionGroup>

        <div
          style={{
            position: "absolute",
            width: this.state.width,
            height: this.state.height,
            left: margin_left
          }}
        >
          {/* Names */}
          <div
            ref={el => (this._donorContainerRef = el)}
            style={{
              position: "absolute",
              width: containerWidth,
              height: containerHeight,
              zIndex: 1,
              top: names_offset,
              opacity: 1
            }}
          >
            <CSSTransitionGroup
              component="div"
              transitionName="slowfade"
              transitionEnterTimeout={0}
              transitionLeaveTimeout={0}
            >
              {this.state.finishedPreRender && this.state.showDonors ? (
                <div
                  key={
                    "donor-index" +
                    this._donorIndex +
                    "-category-index-" +
                    this._categoryIndex
                  }
                >
                  {this.renderNames()}
                </div>
              ) : (
                this.preRenderDonors()
              )}
            </CSSTransitionGroup>
          </div>
        </div>

        {/* Donor list name, category */}
        <CSSTransitionGroup
          component="div"
          transitionName="slowfade"
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}
        >
          <div key={this._donorCounter}>
            {this.state.showDonors ? (
              <div
                key={this._donorCounter}
                style={{
                  position: "absolute",
                  width: this.state.width,
                  height: this.state.height,
                  left: margin_left
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: title_offset,
                    width: this.state.width * 0.9,
                    height: this.state.height * 0.05
                  }}
                >
                  {this.state.listData && this.state.listData.title ? (
                    <div>
                      <div style={titleStyle}>{this.state.listData.title}</div>
                      <div
                        style={{
                          ...subheaderStyle,
                          position: "absolute",
                          top: description_offset
                        }}
                      >
                        {this.state.listData.category}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}
          </div>
        </CSSTransitionGroup>
      </div>
    );
  }
}

export default NewarkDonorList2;



// WEBPACK FOOTER //
// ./src/Components/Theme/Newark/NewarkDonorList2.js